import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import CustomizeOption from '../components/CustomizeOption'
import CustomizeModal from '../components/CustomizeModal';
import { selectFilterData } from '../../mainFilter/selectors';
import DepartureList from '../../mainFilter/filters/Departure/DepartureList';
import { pushEvent } from '../../../utilities/analytics';
import {
  CUSTOMIZE_DEPARTURE_AIRPORT_CLICKED,
  CUSTOMIZE_DEPARTURE_AIRPORT_SAVED,
  OPEN_LOGIN_BLOCK,
  CLOSE_LOGIN_BLOCK,
  MAYBELATER_LOGIN_BLOCK,
} from '../../../constants/analyticEvents';
import api from '../../../api';
import { t } from '../../../utilities/translator';
import { findInArray } from '../../../utilities/helpers';
import { toggleCustomizePanel } from '../customizeButtonSlice';
import { CUSTOMIZE } from '../../../constants/constants';
import LoginBlock from '../../user/LoginBlock';

const MultiDeparture = ({
  onSave,
  selected,
}) => {
  const dispatch = useDispatch();
  const { activePanel } = useSelector(state => state.customize);
  const { searchEngine } = useSelector(selectFilterData);
  const { from_where_groups, fromwhere } = searchEngine;
  const [selectedFilters, setSelectedFilters] = useState(selected);
  const userContext = JSON.parse(localStorage.getItem('hf_user')); // useSelector(selectUser);

  const loginWasClosed = +localStorage.getItem('loginClosed');
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [showLoginBtn, setShowLoginBtn] = useState(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  const loginTriggerTxt = "Departure airports filter (customize filters)";

  useEffect(() => {
    setSelectedFilters(selected);
  }, [selected]);

  useEffect(() => {
    setShowLoginBtn(!((loginWasClosed > Date.now()) || (userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth)));
  }, [loginWasClosed, userContext?.user?.user_auth]);

  const handleCheckbox = (airportCode) => {
    const newSelectedFilters = selectedFilters.map(dep => {
      return {
        ...dep,
        active: (airportCode === dep.id) ? !dep.active : dep.active
      };
    });
    setSelectedFilters(newSelectedFilters);
  };

  const handleCheckboxGroup = (group, value) => {
    const newSelectedFilters = selectedFilters.map(dep => {
      return {
        ...dep,
        active: (group === dep.group_id) ? value : dep.active
      };
    });
    setSelectedFilters(newSelectedFilters);
  }

  const onOpenLogin = () => {
    setLoginOpen(true);
    // eslint-disable-next-line no-undef
    if (typeof closeSubscribeLogin !== 'undefined') {
      // eslint-disable-next-line no-undef
      closeSubscribeLogin();
    }
    pushEvent(OPEN_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupClose = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
    pushEvent(CLOSE_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginPopupCloseLogIn = () => {
    setLoginOpen(false);
    setShowLoginBtn(false);
  };

  useEffect(() => {
    window.addEventListener('userLoggedIn', loginPopupCloseLogIn);

    return () => {
      window.removeEventListener('userLoggedIn', loginPopupCloseLogIn);
    };
  }, []);

  const getOptionLabel = () => {
    if (fromwhere.length === 1) {
      return fromwhere[0].value;
    }

    if (!((userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) || localStorage.getItem('selectedFromwhere') || sessionStorage.getItem('fromWhereOpened'))) {
      return <span className="flex items-center gap-1"><i className="ri-error-warning-line" /><span>{t('mainFilter.setup')}</span></span>;
    }

    const userIsNotNew = !!((userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth && userContext?.user?.originAirports?.length) || localStorage.getItem('selectedFromwhere') || sessionStorage.getItem('fromWhereOpened'));
    const selectedDestinations = selected.filter(dep => dep.active);

    if (!userIsNotNew || selectedDestinations.length === 0) {
      return t('mainFilter.airport_preferences');
    }
    if (selectedDestinations.length === 1) {
      return selectedDestinations[0].value;
    }

    return t('mainFilter.airport_preferences_selected', { departure: selectedDestinations[0].value, count: selectedDestinations.length -1 });
  };

  const handleOptionClick = () => {
    if (fromwhere.length === 1) return;

    dispatch(toggleCustomizePanel(CUSTOMIZE.FROMWHERE));
    if (!sessionStorage.getItem('fromWhereOpened')) {
      sessionStorage.setItem('fromWhereOpened', 1);
    }
    pushEvent(CUSTOMIZE_DEPARTURE_AIRPORT_CLICKED);
  };

  const handleSaveClick = (e, noLogin = false) => {
    if (showLoginBtn && !noLogin) {
      onOpenLogin();
      return false;
    }
    if (!selectedFilters.filter(item => item.active).length) {
      // at least one airport should be selected
      return false;
    }

    // set selected fromWhere to the localStorage for the further pre-selecting
    const selectedFromwhere = selectedFilters.filter((item) => item.active);
    const fromwhereEndDate = new Date();
    fromwhereEndDate.setDate(fromwhereEndDate.getDate() + 365);
    localStorage.setItem(
      'selectedFromwhere',
      JSON.stringify({ fromwhere: selectedFromwhere, date: fromwhereEndDate.getTime() })
    );

    onSave(selectedFilters);
    if (userContext && userContext.user) {
      const newUserContext = { ...userContext };
      const selectedIds = selectedFromwhere.map(item => item.id);
      newUserContext.user.originAirports = selectedIds;
      api.updateContextWithDeparture(newUserContext);
    }
    dispatch(toggleCustomizePanel(null))
    pushEvent(CUSTOMIZE_DEPARTURE_AIRPORT_SAVED);
  };

  const handleClearClick = () => {
    let newSelectedFilters = selectedFilters.map((dep, i) => {
      return {
        ...dep,
        active: dep.ip_selected || false
      };
    });
    const savedFromWhere = JSON.parse(localStorage.getItem('selectedFromwhere'));
    if (savedFromWhere && savedFromWhere.date > new Date().getTime() && savedFromWhere.fromwhere.length) {
      const savedFromIds = savedFromWhere.fromwhere.map(dep => dep.id);
      newSelectedFilters = selectedFilters.map((dep, i) => {
        return {
          ...dep,
          active: findInArray(savedFromIds, dep.id)
        };
      });
    }
    setSelectedFilters(newSelectedFilters);
    onSave(newSelectedFilters);
    dispatch(toggleCustomizePanel(null))
  };

  const handleClose = () => {
    dispatch(toggleCustomizePanel(null))
    setSelectedFilters(selected);
  };

  const loginPopupCloseLater = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    setLoginOpen(false);
    setShowLoginBtn(false);
    localStorage.setItem('loginClosed', +tomorrow);
    setTimeout(() => handleSaveClick(false, true), 350);
    pushEvent(MAYBELATER_LOGIN_BLOCK, { sourceBlock: loginTriggerTxt });
  };

  const loginForm = () => (
    !(userContext && userContext?.user?.userLevel === 'USER_EMAIL' && userContext?.user?.user_auth) &&
      <LoginBlock
        className="login-block-customize"
        onClose={loginPopupClose}
        onCloseLater={loginPopupCloseLater}
        isOpen={isLoginOpen}
        type="departure"
        sourceBlock={loginTriggerTxt}
      />
  );

  return (
    <>
      <CustomizeOption
        label={t('mainFilter.airport_preferences')}
        icon="ri-flight-takeoff-line"
        value={getOptionLabel()}
        onClick={handleOptionClick}
        disabled={fromwhere.length === 1}
      />

      <CustomizeModal
        show={activePanel === CUSTOMIZE.FROMWHERE}
        close={handleClose}
      >
        <CustomizeModal.Header close={handleClose} />
        <CustomizeModal.Body>
          <div className="customize-multi-departure flex flex-col gap-6">
            <div className="text-xl font-semibold text-start">{t('mainFilter.airport_preferences')}</div>
            <span className="font-medium">{t('mainFilter.set_departure_to_preferences')}</span>
            <DepartureList
              departures={selectedFilters}
              fromWhereGroups={from_where_groups}
              handleCheckbox={handleCheckbox}
              handleCheckboxGroup={handleCheckboxGroup}
            />
          </div>
        </CustomizeModal.Body>
        {loginForm()}
        <CustomizeModal.Footer
          close={handleClose}
          onClear={handleClearClick}
          onSave={handleSaveClick}
          disableSave={!selectedFilters.filter(item => item.active).length}
          loginBlock={loginForm()}
        />
      </CustomizeModal>
    </>
  );
};

export default MultiDeparture;
